import { useCallback } from "react";
import { sendGAEvent } from "@next/third-parties/google";
import posthog from "posthog-js";

const DEFAULT_CHANNELS = ["Posthog"];

// Google Analytics only loads on public marketing pages, so callers there opt in to "Google". No
// event goes to the Meta Pixel: it only records page views on those pages.
const useAnalytics = (channels: string[] = DEFAULT_CHANNELS) => {
  // Callers pass array literals, so depend on the choices rather than the array: a new `track` on
  // every render would re-fire every effect that depends on it and send the event again.
  const hasGoogle = channels.includes("Google");
  const hasPosthog = channels.includes("Posthog");

  const track = useCallback(
    (eventName: string, properties: any = {}) => {
      if (hasGoogle) {
        sendGAEvent("event", eventName, properties);
      }
      if (hasPosthog) {
        posthog.capture(eventName, properties);
      }
    },
    [hasGoogle, hasPosthog]
  );

  return track;
};

export default useAnalytics;
